import apiFetch from '../apiFetch'

export default function (token, organizativeUnitId, isFleet) {
  return apiFetch({ endPoint: `OperationTypes/ByOrganizedUnit/${organizativeUnitId}?isFleet=${isFleet}`, method: 'GET', body: null, token: token })
}
